import {createTheme} from "@mui/material/styles";

// Central brand theme so colours, radii and typography are defined once and
// reused across the app. Values mirror the Figma design tokens (and the
// existing CSS variables in App.css) — see EMDRlink "Widok terapeuty" designs.
export const brand = {
    ink: "#0E3C47",        // primary dark teal (App.css --black)
    inkSoft: "#535862",    // secondary text (--grey)
    linkInk: "#134F5C",    // outline button text
    yellow: "#F2D964",     // primary CTA (--yellow)
    yellowInk: "#0B3139",  // text on yellow (--dark-green)
    yellowHover: "#EBCF4E",
    outline: "#90C6D0",    // outline / borders (--light-blue)
    bg: "#EFF8FA",         // app background (--lighter-blue)
    card: "#F8FBFC",       // card background (--white)
    green: "#05603A",      // positive
    greenBg: "#ECFDF3",
    red: "#B42318",        // negative / warning
    redBg: "#FEF3F2",
    placeholder: "#9AA4AC",
};

const theme = createTheme({
    palette: {
        primary: {main: brand.ink, contrastText: "#FFFFFF"},
        secondary: {main: brand.yellow, contrastText: brand.yellowInk},
        success: {main: brand.green, light: brand.greenBg},
        error: {main: brand.red, light: brand.redBg},
        text: {primary: brand.ink, secondary: brand.inkSoft},
        background: {default: brand.bg, paper: brand.card},
    },
    shape: {borderRadius: 12},
    typography: {
        fontFamily: '"General Sans", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        button: {textTransform: "none", fontWeight: 600},
    },
    components: {
        MuiButton: {
            defaultProps: {disableElevation: true},
            styleOverrides: {
                root: {borderRadius: 999, textTransform: "none", fontWeight: 600},
            },
        },
    },
});

export default theme;
